import React from "react";
import { Box, Button, Typography } from "@mui/material";
import dogWalking from "../../../assets/dog-walking.gif";
import { motion } from "framer-motion";
import GlassMediaLoader from "./GlassMediaLoader";

export default function LoadingMessage({ mediaType, videoReady, onViewVideo }) {
  const isVideo = String(mediaType ?? "").toLowerCase() === "video";

  return (
    <Box sx={{ position: "relative" }}>
      <GlassMediaLoader mediaType={mediaType} mode="generating" />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <motion.div
          animate={{ rotate: 0 }}
          transition={{ repeat: Infinity, duration: 4, ease: "linear" }}
        >
          <img
            src={dogWalking}
            alt="Loading animation"
            style={{ width: 72, height: 72 }}
          />
        </motion.div>

        <Typography
          variant="caption"
          sx={{ mt: 1.5, color: "rgba(255,255,255,0.7)", fontSize: 11 }}
        >
          {isVideo && videoReady
            ? "VIDEO READY"
            : `GENERATING ${
          String(mediaType ?? "").toLowerCase() === "content"
            ? "SCRIPT"
            : mediaType?.toUpperCase()
              }...`}
        </Typography>

        {isVideo && videoReady && (
          <Button
            size="small"
            variant="contained"
            onClick={onViewVideo}
            sx={{
              mt: 1.5,
              px: 2,
              py: 0.5,
              borderRadius: 999,
              fontSize: 12,
              fontWeight: 700,
              textTransform: "none",
              color: "#1f2937",
              background: "#f8fafc",
              boxShadow: "none",
              "&:hover": {
                background: "#e5e7eb",
                boxShadow: "none",
              },
            }}
          >
            View video
          </Button>
        )}
      </Box>
    </Box>
  );
}